import { useEffect } from 'react';

export const useScrollbarWidth = () => {
  useEffect(() => {
    const getScrollbarWidth = () => {
      const scroller = document.scrollingElement as HTMLElement;
      if (!scroller) {
        return;
      }
      scroller.style.setProperty('--scrollbar-width', `${window.innerWidth - scroller.clientWidth}px`);
    };

    getScrollbarWidth();

    window.addEventListener('resize', getScrollbarWidth);

    return () => window.removeEventListener('resize', getScrollbarWidth);
  }, []);
};
